import type {
  Availability,
  ProductStatus,
} from '@eliadmin/core/src/api/products/types/product-types';
import { ProductStatusText } from '@eliadmin/core/src/components/product/product-status-text';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../../ui/heading';

export function ProductDetailAvailability({
  availability,
  status,
}: {
  availability: Availability;
  status?: string | null;
}) {
  if (status === 'ended' || status === 'arrival') {
    return <ProductStatusText status={status} />;
  }

  return (
    <div className={cn('flex items-center justify-start gap-3')}>
      <div
        className={cn('relative z-10 h-3 w-3 rounded-full')}
        style={{ backgroundColor: availability?.color || '#E0E0E0' }}
      >
        <div
          className={cn(
            'absolute left-1/2 top-1/2 z-[5] h-5 w-5 -translate-x-1/2 -translate-y-1/2 rounded-full opacity-15',
          )}
          style={{ backgroundColor: availability?.color || '#E0E0E0' }}
        />
      </div>
      <Heading tag="p" styleAs="h6" title={availability?.name} />
    </div>
  );
}
